import React, { useState } from "react";
import { Space, Button, Modal, Radio, Table, Input, message } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import { observer } from "mobx-react";
import { changeRequestStore } from "../../../store/childchange/ChangeRequestStore";

export const ApproveReject = observer(({ item, small = false }) => {
  const [showApprove, setShowApprove] = useState(false);
  const [showCustom, setShowCustom] = useState(false);
  const [saving, setSaving] = useState(false);
  const [reason, setReason] = useState("");
  const [attrs, setAttrs] = useState(item.attrs);
  const onApproveAll = () => {
    setSaving(true);
    changeRequestStore
      .confirm({ id: item.id, ...changeRequestStore.resultAll(item.attrs, true) })
      .then(() => {
        setShowApprove(false);
      })
      .finally(() => {
        setSaving(false);
      });
  };

  const onCustom = () => {
    let data: any = { reason };
    if (attrs.filter((x) => !x.result).length > 0) {
      if (!reason.trim()) {
        message.error("Reject reason is required.");
        return;
      }
    }
    for (let attr of attrs) {
      if (attr.type === "First Name") {
        data = { ...data, firstName: attr.result };
      } else if (attr.type === "Last Name") {
        data = { ...data, lastName: attr.result };
      } else if (attr.type === "Grade") {
        data = { ...data, grade: attr.result };
      } else if (attr.type === "School") {
        data = { ...data, school: attr.result };
      }
    }

    setSaving(true);
    changeRequestStore
      .confirm({ id: item.id, ...data })
      .then(() => {
        setReason("");
        setShowCustom(false);
      })
      .finally(() => {
        setSaving(false);
      });
  };

  const onOpt = (i, e) => {
    attrs[i].result = e.target.value;
    setAttrs([...attrs]);
    console.log("on opt,", i, e);
  };

  const columns = [
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
    },

    {
      title: "Existing Info",
      key: "from",
      dataIndex: "from",
    },
    {
      title: "Proposed Info",
      key: "to",
      dataIndex: "to",
    },
    {
      title: "Approve / Reject",
      key: "opt",
      render: (v, r, i) => (
        <Radio.Group onChange={(v) => onOpt(i, v)} value={r.result}>
          <Radio value={true}>Approve</Radio>
          <Radio value={false}>Reject</Radio>
        </Radio.Group>
      ),
    },
  ];

  return (
    <>
      <Space>
        <Button
          type={small ? "link" : "primary"}
          icon={small ? <CheckCircleOutlined /> : null}
          onClick={() => setShowApprove(true)}
        >
          {small ? "" : "Approve All"}
        </Button>
        <Button icon={small ? <CheckCircleOutlined /> : null} onClick={() => setShowCustom(true)}>
          {small ? "" : "Custom"}
        </Button>
      </Space>
      {showCustom && (
        <Modal
          confirmLoading={saving}
          visible={true}
          title="Approve / Reject"
          onCancel={() => setShowCustom(false)}
          onOk={onCustom}
        >
          <Table size="small" pagination={false} rowKey="type" columns={columns} dataSource={attrs} />
          <Input.TextArea value={reason} onChange={(e) => setReason(e.target.value)}></Input.TextArea>
        </Modal>
      )}
      {showApprove && (
        <Modal
          title="Approve All"
          visible={showApprove}
          onOk={onApproveAll}
          confirmLoading={saving}
          onCancel={() => setShowApprove(false)}
        >
          <p>Are you sure to Approve All change?</p>
        </Modal>
      )}
    </>
  );
});
